import { Dashboard } from './Dashboard.jsx';

export default {
  path: '/dashboard',
  element: <Dashboard />,
  protected: true,
  permission: 'dashboard.view',
  standalone: false,
  sidebar: { label: 'الرئيسية', icon: 'dashboard', group: 'main', order: 10 }
};
